import axios from "axios";
import { API_TRABALHE_CONOSCO_RHX } from "../consts/api";

export function verificarCPFExiste(cpf) {
  try {
    return axios.post(API_TRABALHE_CONOSCO_RHX.verificarCPF, { cpf }).then(response => {
      const data = response.data;
      if (data.mensagem === "cadastrado") {
        return true;
      } else {
        return false;
      }
    });
  } catch (e) {
    throw e;
  }
}

export async function enviarLinkRecuperacao(cpf) {
  try {
    return axios.post(API_TRABALHE_CONOSCO_RHX.recuperar, { cpf }).then(response => {
      return response.data.email;
    });
  } catch (error) {
    throw error;
  }
}

export function listarCidades() {
  try {
    return axios.get(API_TRABALHE_CONOSCO_RHX.cidades).then(response => response.data);
  } catch (error) {
    throw error;
  }
}

export function listarSetore() {
  try {
    return axios
      .get(API_TRABALHE_CONOSCO_RHX.setores)
      .then(response => response.data.filter(setor => setor.ativo));
  } catch (error) {
    throw error;
  }
}

export function listarPerguntas() {
  try {
    return axios
      .get(API_TRABALHE_CONOSCO_RHX.perguntas)
      .then(response => response.data.filter(pergunta => pergunta.ativo));
  } catch (error) {
    throw error;
  }
}

export function listarEscolaridades() {
  try {
    return axios.get(API_TRABALHE_CONOSCO_RHX.escolaridade).then(response => response.data);
  } catch (error) {
    throw error;
  }
}

export function listarEstadosCivis() {
  try {
    return axios.get(API_TRABALHE_CONOSCO_RHX.estadosCivis).then(response => response.data);
  } catch (error) {
    throw error;
  }
}

export function listarRedesSociais() {
  try {
    return axios.get(API_TRABALHE_CONOSCO_RHX.redesSociais).then(response => response.data);
  } catch (error) {
    throw error;
  }
}

export function listarFaixaSalarial() {
  try {
    return axios.get(API_TRABALHE_CONOSCO_RHX.faixaSalarial).then(response => response.data);
  } catch (error) {
    throw error;
  }
}

export function cadastrarCadidato(formData) {
  try {
    return axios.post(API_TRABALHE_CONOSCO_RHX.cadastrar, formData);
  } catch (e) {
    throw e;
  }
}

export function atualizarCadidato(formData, token) {
  try {
    return axios.post(API_TRABALHE_CONOSCO_RHX.cadastrar + "/" + token, formData, {
      params: {
        _method: "PUT"
      }
    });
  } catch (e) {
    throw e;
  }
}

export function validarTokenAtualizacao(token) {
  return axios
    .get(API_TRABALHE_CONOSCO_RHX.validarToken + token)
    .then(response => response.data.id)
    .catch(() => false);
}

export function detalharCandidato(id) {
  try {
    return axios.get(API_TRABALHE_CONOSCO_RHX.detalhar + id).then(response => response.data);
  } catch (error) {
    throw error;
  }
}

export const camposDefault = {
  nome: "", //*
  cpf: "", //""*
  telefone: "", //*
  arquivo: null, //--
  arquivoTexto: "", //--
  foto: null, //--
  fotoTexto: "", //--
  email: "", //*
  quantidadeFilhos: 0, //*
  dataNascimento: null, //*
  nomeContato: "", //*
  telefoneContato: "", //*
  referenciasNaEmpresa: "", //*
  escolaridades: [], //*
  experiencias: [], //*
  qualificacoes: [], //*
  habilidades: "", //*
  referenciasPessoais: [], //*
  respostas: [], //*
  redesSociais: [], //*
  cidade: "", //*
  estadoCivil: "", //*
  setorInteresse: "", //*
  faixaSalarial: "" //*
};
